module.exports = __webpack_public_path__ + "img/sended.32d8c9a2.svg";